import { queryOptions } from '@tanstack/react-query';
import API from '@/api';
import { queryKeys } from '@/api/utils/queryKeys';

export const meQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.me,
    queryFn: API.me.getMe,
    staleTime: Infinity,
  });
